import { Dialog, VisuallyHidden } from "radix-ui";
import type { ReactNode } from "react";

import styles from "./Modal.module.css";
import { cx } from "../lib/cx";

export type ModalProps = {
  readonly children: ReactNode;
  readonly className?: string;
  readonly onClose: () => void;
  readonly open: boolean;
  readonly title: string;
};

export const Modal = ({
  children,
  className,
  onClose,
  open,
  title,
}: ModalProps) => (
  <Dialog.Root
    onOpenChange={(next) => {
      if (!next) {
        onClose();
      }
    }}
    open={open}
  >
    <Dialog.Portal>
      <Dialog.Overlay className={cx(styles.overlay, "u-fade")} />
      <Dialog.Content
        aria-describedby={undefined}
        className={cx(styles.content, className)}
      >
        <VisuallyHidden.Root>
          <Dialog.Title>{title}</Dialog.Title>
        </VisuallyHidden.Root>
        {children}
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
